import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SyncStatusState } from './types'

const initialState: SyncStatusState = {
  resources: {}
}

export const syncStatusSlice = createSlice({
  name: 'syncStatus',
  initialState,
  reducers: {
    setSyncTime: (
      state,
      action: PayloadAction<{ resource: string; time: string }>
    ) => {
      state.resources[action.payload.resource] = action.payload.time
    }
  }
})

export const reducer = syncStatusSlice.reducer

export const { setSyncTime } = syncStatusSlice.actions
